import React from 'react'

const LoadingIndicator = () => <div className="spinner-sm" style={{marginRight: '10px'}} />

export default LoadingIndicator
